import React, { useEffect } from "react";

import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import { getPeriodName } from "../../../services/SchoolService";

function PeriodSelector({ sx={}, school, onChangePeriod, showAllPeriods = false, labelText="Select Period: *" }) {
  const [_selectedPeriod, setSelectedPeriod] = React.useState("1");

  useEffect(() => {
    if (showAllPeriods === true)  {
      setSelectedPeriod("XX");
    } else {
      setSelectedPeriod("1");
    }
  }, []);

  const handleChangePeriod = (event) => {
    setSelectedPeriod(event.target.value);
    if (onChangePeriod) {
      onChangePeriod(event.target.value);
    }
  };

  return (
    <>
      <InputLabel sx={sx}>{labelText}</InputLabel>
      <Select
        sx={{ mb: 1 }}
        fullWidth
        size="small"
        onChange={handleChangePeriod}
        value={_selectedPeriod}
      >
        {showAllPeriods === true && (
          <MenuItem key={"XX"} value={"XX"}>
            -- ALL PERIODS --
          </MenuItem>
        )}
        {[...Array(school.maxActivityCount)].map((x, i) => (
          <MenuItem key={i + 1} value={i + 1}>
            {getPeriodName(school, i)}
          </MenuItem>
        ))}
      </Select>
    </>
  );
}

export default PeriodSelector;
